import { render, staticRenderFns } from "./ThankLetter.vue?vue&type=template&id=66c05178"
import script from "./ThankLetter.vue?vue&type=script&lang=js"
export * from "./ThankLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c05178')) {
      api.createRecord('66c05178', component.options)
    } else {
      api.reload('66c05178', component.options)
    }
    module.hot.accept("./ThankLetter.vue?vue&type=template&id=66c05178", function () {
      api.rerender('66c05178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/ThankLetter.vue"
export default component.exports